import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { PublicAuthShell } from "./PublicAuthShell";
import { colors } from "../../data/tokens";

// Mostrada no endereço do cadastro público enquanto ele estiver desativado
// (PUBLIC_REGISTRATION_ENABLED em data/features.ts): quem tiver o link
// salvo recebe uma explicação em vez de um formulário.
export const RegisterDisabledPage = () => {
  return (
    <PublicAuthShell
      title="Cadastro indisponível"
      subtitle="O cadastro de novos sócios pelo site está desativado no momento.">
      <Typography
        sx={{
          fontSize: 14,
          color: colors.textSecondary,
          textAlign: "center",
          marginBottom: 2.5,
        }}>
        Para se associar, entre em contato com a secretaria do Clube de
        Engenharia.
      </Typography>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        sx={{ height: 48 }}
        onClick={() => {
          window.location.href = window.location.origin + "/#/login";
        }}>
        Ir para o login
      </Button>
    </PublicAuthShell>
  );
};
